import { useAsyncExecutor, useAsyncExecutor2 } from "async-executor-hook";
import { useContext, useState } from "react";

import { Authorization } from "../../common/AuthorizationCpt";
import { ContainerScrollCommon } from "../../common/components/TableResponsive";
import AddIcon from "../../images/ic_add_contado_method.svg";
import DeleteIcon from "../../images/icon_delete.svg";
import LoadingSpinner from "../../images/loading_gray.gif";
import PDFIcon from "../../images/icon_pdf.svg";
import LoadingGray from "../../images/loading_gray.gif";
import LogoBBVA from "../../images/logo_BBVA.svg";
import LogoBCP from "../../images/logo_BCP.svg";
import LogoInterbank from "../../images/logo_INTERBANK.svg";
import LogoNacion from "../../images/logo_NACION.svg";
import LogoScotiabank from "../../images/logo_SCOTIABANK.svg";
import {
  BANKS,
  CURRENCIES,
  getCurrencyObject,
  HTTP_METHODS,
} from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { separator } from "../../utils/paymentMethodUtils";
import { CurrencyContext } from "../CurrencyContext/CurrencyContext";
import Select from "../Select/Select";
import {
  ButtonWhiteConfigurate,
  Container,
  DivAddPaymentVoucher,
  DivBank,
  DivFlexBetween,
  DivFlexRuc,
  DivImageSize,
  DivPaymentVoucher,
  DivRucFac,
  DivRucName,
  DivSelectMoney,
  DivVolanteId,
  DivVouchers,
  FileInfoVoucher,
  InvoiceContainer,
  InvoicesContainer,
  MainButton,
  PaymentContainer,
} from "./ContadoMethodStyles";
import { formatSize } from "./FileUploadInputDirectMethod";
import { getErrorValueResponse } from "../../common/error/Error";
import { uploadFileToS3 } from "../../utils/s3Upload";
import { DivIsLoadingIcon } from "../CollectionMethod/CollectionMethodStyles";
interface IVoucher {
  voucher_document: string;
  bank_option: string;
  payment_currency: string;
}

interface IUpfrontManualBody {
  quotation_ids: string[];
  payment_type_option: string;
  payment_currency: string;
  upfront_manual_payment_details: IVoucher[];
}

const ContadoMethodPayment = (props) => {
  const {
    invoices,
    loadUpfrontManual,
    setShowModalConfirmation,
    setShowModalImportantVoucher,
    updateShowModal,
    setShowModalSuccessContadoMethod,
    setShowModalErrorContadoMethod,
    setShoModalMessageContadoMethod,
    dataComprobantes,
    removeComprobante,
    countPageRedirect,
    dateUrlQuotationQuoted,
    volateQuoted,
    quotation_ids,
    getQuotationQuotedVolantes,
    clearShoppingCar,
  } = props;
  const [useDollars, updateUseDollars] = useContext(CurrencyContext);
  const [currency, updateCurrency] = useState(
    getCurrencyObject(useDollars).value
  );

  const onCurrencyChange = (e) => {
    updateCurrency(e.target.value);
    updateUseDollars(e.target.value === "pen" ? false : true);
  };

  const saveContadoMethod = useAsyncExecutor(
    async (params: any) => {
      const { quotation_ids } = params;
      const promiseVouchers: Promise<IVoucher>[] = params.dataComprobantes.map(
        async (voucher: IVoucher & { selectMyFile: string[] }) => {
          const file = voucher.selectMyFile[0];
          const respS3 = await uploadFileToS3(
            "third-party-credit-authorization",
            [file],
            "autorizacion_uso_linea_credito_"
          );
          return {
            bank_option: voucher.bank_option,
            payment_currency: voucher.payment_currency,
            voucher_document: respS3[0],
          };
        }
      );
      const vouchers = await Promise.all(promiseVouchers);
      const body: IUpfrontManualBody = {
        quotation_ids,
        payment_currency: params.currency,
        payment_type_option: "upfront_manual",
        upfront_manual_payment_details: vouchers,
      };
      return networkBackendRequest(
        `/invoices/upfront-manual/`,
        HTTP_METHODS.POST,
        null,
        body
      ).then((response) => response.json());
    },
    {
      onSuccess: () => {
        getQuotationQuoted.execute({ from_date: dateUrlQuotationQuoted });
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        clearShoppingCar();
        setShoModalMessageContadoMethod(errorMessage);
        setShowModalErrorContadoMethod(true);
        updateShowModal(false);
      },
    }
  );

  const getQuotationQuoted: any = useAsyncExecutor2(
    (params: any) => {
      return networkBackendRequest(`/quotations/quoted/`, HTTP_METHODS.GET, {
        from_date: params.from_date,
      }).then((resp) => resp.json());
    },
    {
      onSuccess: (data) => {
        const count = data.count;
        countPageRedirect(count);
        updateShowModal(false);
        setShowModalSuccessContadoMethod(true);
      },
      onError: () => {
        countPageRedirect(1);
        updateShowModal(false);
        setShowModalSuccessContadoMethod(true);
      },
    }
  );

  const optionBanks = (option) => {
    switch (option) {
      case BANKS.bcp.code:
        return (
          <DivImageSize>
            <img src={LogoBCP} alt="" className="icon-image-bank" />
          </DivImageSize>
        );
      case BANKS.bbva.code:
        return (
          <DivImageSize>
            <img src={LogoBBVA} alt="" className="icon-image-bank" />
          </DivImageSize>
        );
      case BANKS.interbank.code:
        return (
          <DivImageSize>
            <img src={LogoInterbank} alt="" className="icon-image-bank" />
          </DivImageSize>
        );
      case BANKS.scotiabank.code:
        return (
          <DivImageSize>
            <img src={LogoScotiabank} alt="" className="icon-image-bank" />
          </DivImageSize>
        );
      case BANKS.nacion.code:
        return (
          <DivImageSize>
            <img src={LogoNacion} alt="" className="icon-image-bank" />
          </DivImageSize>
        );
      default:
        break;
    }
  };

  return (
    <Container>
      <h1>Forma de pago: Al Contado</h1>
      <h2 style={{ color: "#989CA2", fontWeight: 500, fontSize: "1.5rem" }}>
        Debe pagar la prefactura antes de la medianoche
      </h2>
      <div className="currency--container">
        <DivSelectMoney>SELECCIONE MONEDA</DivSelectMoney>
        <Select
          className="clickable-element"
          onChange={onCurrencyChange}
          height="4.5rem"
          width="100%"
          arrowPosition="1.6rem"
          value={currency}
        >
          {CURRENCIES.map((currencyElem, index) => (
            <option key={index} value={currencyElem.value}>
              {currencyElem.label}
            </option>
          ))}
        </Select>
      </div>
      <ContainerScrollCommon>
        <div
          style={{
            overflowY: "scroll",
            maxHeight: "35vh",
          }}
          className="scroll"
        >
          <InvoicesContainer>
            {getQuotationQuotedVolantes.isLoading && (
              <DivIsLoadingIcon>
                <img src={LoadingGray} className="icon" alt="Loading screen" />
              </DivIsLoadingIcon>
            )}
            {volateQuoted &&
              volateQuoted.map((invoice) => (
                <InvoiceContainer key={invoice.id}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ marginRight: "2rem" }}>
                      <DivVolanteId>{invoice.volanteId}</DivVolanteId>
                    </div>
                    <DivFlexRuc>
                      <DivRucFac>RUC FACTURABLE</DivRucFac>
                      <DivRucName>
                        {invoice.ruc.ruc} - {invoice.ruc.name}
                      </DivRucName>
                    </DivFlexRuc>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <p className="invoice-id">{invoice.quotationNum}</p>
                    <p className="importer">{invoice.importer}</p>
                  </div>
                </InvoiceContainer>
              ))}
          </InvoicesContainer>
        </div>
      </ContainerScrollCommon>

      <PaymentContainer>
        <div className="special-row">
          <p>Total factura</p>
          {loadUpfrontManual.isLoading && (
            <img src={LoadingGray} className="icon" alt="Loading screen" />
          )}
          {loadUpfrontManual.isSuccess && (
            <p>
              {currency === "usd"
                ? `$ ${separator(
                    loadUpfrontManual.data.sales_invoice_total.usd
                  )} dólares`
                : `S/. ${separator(
                    loadUpfrontManual.data.sales_invoice_total.pen
                  )} soles`}
            </p>
          )}
        </div>
      </PaymentContainer>
      <div className="rows-wrapper">
        <div>
          <DivVouchers>Comprobantes de pago</DivVouchers>
          {dataComprobantes.map((data, index) => {
            return (
              <div style={{ display: "flex" }} key={index}>
                <DivBank>
                  {optionBanks(data.bank_option)}
                  <div style={{ fontSize: "1.4rem", fontWeight: 500 }}>
                    {data.payment_currency === "pen" ? "Soles" : "Dólares"}
                  </div>
                </DivBank>
                <FileInfoVoucher>
                  <DivFlexBetween>
                    <div>
                      <img src={PDFIcon} alt="PDFIcon" />
                    </div>
                    <div>
                      <p style={{ overflowWrap: "break-word", width: "38rem" }}>
                        {data.name_doc}
                      </p>
                    </div>
                    <div>
                      <p className="size">{formatSize(data.size_doc)}</p>
                    </div>
                    <div>
                      <img
                        style={{
                          cursor: `${
                            saveContadoMethod.isLoading ||
                            getQuotationQuoted.isLoading
                              ? "not-allowed"
                              : "pointer"
                          }`,
                        }}
                        className="delete-icon"
                        src={DeleteIcon}
                        alt="DeleteIcon"
                        onClick={() => {
                          if (
                            !(
                              saveContadoMethod.isLoading ||
                              getQuotationQuoted.isLoading
                            )
                          ) {
                            removeComprobante(index);
                          }
                        }}
                      />
                    </div>
                  </DivFlexBetween>
                </FileInfoVoucher>
              </div>
            );
          })}
          {dataComprobantes.length < 20 && (
            <DivPaymentVoucher>
              <DivAddPaymentVoucher>
                Añadir comprobante de pago
              </DivAddPaymentVoucher>
              {!(
                saveContadoMethod.isLoading || getQuotationQuoted.isLoading
              ) && (
                <ButtonWhiteConfigurate
                  width={"14rem"}
                  minHeight={"4.5rem"}
                  backgroundColor={"#FFFFFF"}
                  color="#88B13B"
                  marginRight="1rem"
                  onClick={() => {
                    setShowModalImportantVoucher(true);
                    setShowModalConfirmation(false);
                  }}
                  disabled={volateQuoted.length < 1}
                >
                  <img src={AddIcon} alt="" style={{ marginRight: "1.1rem" }} />
                  Añadir
                </ButtonWhiteConfigurate>
              )}
            </DivPaymentVoucher>
          )}
        </div>
      </div>
      <div>
        <Authorization actions={["invoice.create_invoice_upfront_manual"]}>
          <MainButton
            onClick={() => {
              saveContadoMethod.execute({
                invoices,
                currency,
                dataComprobantes,
                quotation_ids,
              });
            }}
            disabled={
              dataComprobantes.length < 1 ||
              saveContadoMethod.isLoading ||
              getQuotationQuoted.isLoading
            }
            isLoading={
              saveContadoMethod.isLoading || getQuotationQuoted.isLoading
            }
          >
            {(saveContadoMethod.isLoading || getQuotationQuoted.isLoading) && (
              <img
                src={LoadingSpinner}
                className="icon"
                alt="Processing request"
              />
            )}
            Confirmar pago
          </MainButton>
        </Authorization>
      </div>
    </Container>
  );
};
export default ContadoMethodPayment;
